<div class="manage-users m-auto mt-5">
    <section class="card shadow-sm-darker mb-4">
        <form [formGroup]="form" (ngSubmit)="onboardStudent()" class="mb-0">
            <h3 class="card-header mb-0">Course Onboarding</h3>
            <div class="card-body">
                <div class="fieldset w-100">
                    <label class="legend">First Name<span class="requiredfield">*</span></label>
                    <input type="text" class="text-field" formControlName="fname">
                    <small *ngIf="f.fname.touched && f.fname.invalid">
                        First name is required
                    </small>
                </div>

                <div class="fieldset w-100">
                    <label class="legend">Last Name<span class="requiredfield">*</span></label>
                    <input type="text" class="text-field" formControlName="lname">
                    <small *ngIf="f.lname.touched && f.lname.invalid">
                        Last name is required
                    </small>
                </div>

                <div class="fieldset w-100">
                    <label class="legend">Password<span class="requiredfield">*</span></label>
                    <input type="password" class="text-field" formControlName="password">
                    <small *ngIf="f.password.touched && f.password.errors?.['required']">
                        Password is required
                    </small>

                    <small *ngIf="f.password.errors?.['minlength']">
                        Minimum 8 characters
                    </small>

                    <small *ngIf="f.password.errors?.['pattern']">
                        Must include uppercase, lowercase, number, and special character
                    </small>
                    <div class="password-strength">
                        <div class="strength-bar" [style.width.%]="(strength / 6) * 100"></div>
                    </div>                    
                    {{ strengthLabel }}
                </div>

                <div class="fieldset w-100">
                    <label class="legend">Confirm Password<span class="requiredfield">*</span></label>
                    <input type="password" class="text-field" formControlName="cpassword">
                    <small *ngIf="f.cpassword.touched && f.cpassword.invalid">
                        Confirm your password
                    </small>
                    <small *ngIf="form.errors?.['passwordMismatch'] && f.cpassword.touched">
                        Passwords do not match
                    </small>
                </div>

            </div>

            <div class="card-footer">
                <button type="submit" [disabled]="form.invalid" class="btn">
                    Submit
                </button>
            </div>

        </form>
    </section>
</div>